import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal, { IModalChildProps } from '../../common/modal';

const DeleteUserModal = ({ onAccept, onClose }: IModalChildProps) => {
    return (
        <Modal>
            <>
                <div className="modal-header">
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title">
                        <FormattedMessage
                            id="Confirm_Delete_User_Title"
                            defaultMessage="Are you sure you want to delete this user?"
                        />
                    </h4>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-danger" onClick={onAccept}>
                        <FormattedMessage id="Delete_User" />
                    </button>
                    <button
                        type="button"
                        className="btn btn-default"
                        onClick={onClose}
                    >
                        <FormattedMessage id="Cancel" />
                    </button>
                </div>
            </>
        </Modal>
    );
};

export default DeleteUserModal;
